
export default {
  actions: {
    setDestination({ commit }, destination) {
      commit('setDestination', destination);
    },
  },
}